'use client';

import React from 'react';
import styles from './feature-selector.module.scss';

interface FeatureCardProps {
    title: string;
    description: string;
    isSelected: boolean;
    onClick: () => void;
    className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
    title,
    description,
    isSelected,
    onClick,
    className,
}) => {
    return (
        <article
            className={`${className}`}
            onClick={onClick}
            style={{
                backgroundColor: isSelected ? '#FFF' : '#F6F7F9',
                boxShadow: isSelected
                    ? '0 0.2rem 0.4rem 0 rgb(6 17 118 / 8%), 0 0.4rem 1.2rem 0 rgb(6 17 118 / 8%)'
                    : 'none',
            }}
        >
            <div className={styles.cardContentWrapper}>
                <div className={styles.cardContent}>
                    <h3 className={styles.cardTitle}>{title}</h3>
                    <p className={styles.cardDescription}>{description}</p>
                </div>
            </div>
        </article>
    );
};

export {FeatureCard};
